import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useAuth } from '../../context/AuthContext'
import Form from '../form/Form'
import { handleFileUpload } from '../../utils/documentManager'
import { useCallback, useEffect, useRef, useState } from 'react'

function UploadFileDialog({ onClose, setObject, setRefresh, id: idProp, objectType: objectTypeProp, open, ...other }) {
  const { user } = useAuth()
  const location = useLocation()
  const toastId = useRef(null)

  const [fileData, setFileData] = useState({
    type: objectTypeProp,
    parentId: idProp
  })
  const [checkForm, setCheckForm] = useState(false)
  const [errors, setErrors] = useState(null)
  const [isSubmit, setIsSubmit] = useState(false)

  const handleCancel = () => {
    setFileData({ type: objectTypeProp, parentId: idProp })
    setCheckForm(false)
    setErrors(null)
    setIsSubmit(false)
    onClose()
  }

  const handleOk = () => setCheckForm(true)

  const uploadFile = useCallback(async () => {
    try {
      toastId.current = toast.loading('Enregistrement en cours')

      await handleFileUpload(
        fileData.file,
        user,
        fileData.name,
        fileData.type,
        { id: fileData.parentId, attachments: [] },
        setObject
      )

      setRefresh(true)
      setFileData({ type: objectTypeProp, parentId: idProp })

      toast.update(toastId.current, {
        type: 'success',
        render: 'Enregistrement terminé',
        autoClose: 2000,
        isLoading: false
      })

      onClose()
    } catch (e) {
      const errorMessage = e?.response?.statusText || e.message
      if (toastId.current) {
        toast.update(toastId.current, {
          type: 'error',
          render: errorMessage,
          autoClose: 2000,
          isLoading: false
        })
      } else {
        toast.error(errorMessage)
      }
    }
  }, [fileData, user, objectTypeProp, idProp, setObject, setRefresh, onClose])

  useEffect(() => {
    if (isSubmit) {
      uploadFile()
      setIsSubmit(false)
    }
  }, [isSubmit, uploadFile])

  const options = {
    fields: [
      [
        {
          name: 'file',
          label: 'Logo',
          type: 'file',
          validation: [
            { rule: 'req', error: 'Veuillez choisir un fichier' },
            { rule: 'fileSizeMax=10', error: 'Taille de fichier supérieure à 10MB' }
          ]
        }
      ],
      [
        {
          name: 'name',
          label: 'Classification',
          type: 'select',
          required: true,
          options: {
            type: 'api',
            object: 'classifications',
            returnField: 'name',
            value: 'label',
            filter: () => ({ type: objectTypeProp })
          },
          validation: [
            { rule: 'req', error: 'Classification obligatoire' },
            {
              rule: 'classification',
              error: 'Choisissez un autre type de fichier',
              filter: (file) => ({
                parentType: objectTypeProp,
                parentId: idProp,
                type: file.name
              }),
              subfilter: (file) => ({
                type: objectTypeProp,
                name: file.name
              })
            }
          ]
        }
      ]
    ],
    data: fileData,
    location
  }

  return (
    <Dialog open={open} maxWidth='md' sx={{ '& .MuiDialog-paper': { maxHeight: 500 } }} {...other}>
      <DialogTitle>Ajouter Fichier</DialogTitle>
      <DialogContent dividers>
        <Box>
          <Form
            options={options}
            checkForm={checkForm}
            setCheckForm={setCheckForm}
            setDataParent={setFileData}
            setFormError={setErrors}
            setIsSubmitParent={setIsSubmit}
            modeProps='wizard'
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Annuler</Button>
        <Button onClick={handleOk}>Envoyer</Button>
      </DialogActions>
    </Dialog>
  )
}

export default UploadFileDialog
